var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_27",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("rect", {
        staticStyle: { fill: "none", "stroke-width": "0px" },
        attrs: { x: "41.815", y: "38.303", width: "16.576", height: "1.845" },
      }),
      _c("rect", {
        staticStyle: { fill: "none", "stroke-width": "0px" },
        attrs: { x: "64.891", y: "38.303", width: "16.575", height: "1.845" },
      }),
      _c("rect", {
        staticStyle: { fill: "none", "stroke-width": "0px" },
        attrs: { x: "12.651", y: "57.828", width: "1.861", height: "15.244" },
      }),
      _c("rect", {
        staticStyle: { fill: "none", "stroke-width": "0px" },
        attrs: { x: "18.741", y: "38.303", width: "16.575", height: "1.845" },
      }),
      _c("rect", {
        staticStyle: { fill: "none", "stroke-width": "0px" },
        attrs: { x: "85.487", y: "57.828", width: "1.862", height: "15.244" },
      }),
      _c("path", {
        staticStyle: { fill: "#fff", "stroke-width": "0px" },
        attrs: {
          d: "m18.06,87.41c.112.18.307.287.519.287h16.694c.213,0,.406-.107.519-.287l.743-1.188h-19.209l.734,1.188Z",
        },
      }),
      _c("rect", {
        staticStyle: { fill: "#fff", "stroke-width": "0px" },
        attrs: { x: "16.263", y: "75.072", width: "21.325", height: "9.4" },
      }),
      _c("rect", {
        staticStyle: { fill: "#fff", "stroke-width": "0px" },
        attrs: { x: "16.263", y: "57.828", width: "21.325", height: "15.244" },
      }),
      _c("path", {
        staticStyle: { fill: "#fff", "stroke-width": "0px" },
        attrs: {
          d: "m37.013,43.198l-.663-1.3h-18.848l-.663,1.3c-.377.739-.576,1.567-.576,2.396v10.234h21.325v-10.234c0-.828-.199-1.657-.575-2.396Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m36.534,86.223l-.743,1.188c-.112.18-.306.287-.519.287h-16.694c-.212,0-.406-.107-.519-.287l-.734-1.188h-1.938v-1.75h.875v-9.4h-1.75v9.432c0,.349.098.691.285.994l1.778,2.841c.435.694,1.184,1.108,2.002,1.108h16.694c.82,0,1.568-.415,2.002-1.109l1.188-1.898-.136-.217h-1.792Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m16.263,55.828v-10.234c0-.829.199-1.657.576-2.396l.663-1.3h18.848l.663,1.3c.376.739.575,1.568.575,2.396,0-1.105.265-2.208.767-3.191l.108-.212-.66-1.294c-.158-.309-.425-.529-.736-.648v.775h-1.75v-.875h-16.575v.875h-1.75v-.837c-.402.084-.751.334-.944.712l-.767,1.504c-.502.984-.768,2.087-.768,3.191v10.234h1.75Z",
        },
      }),
      _c("polygon", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          points:
            "35.316 40.148 35.316 41.023 37.066 41.023 37.066 40.248 37.066 38.303 35.316 38.303 35.316 40.148",
        },
      }),
      _c("polygon", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          points:
            "18.741 41.023 18.741 40.148 18.741 38.303 16.991 38.303 16.991 40.187 16.991 41.023 18.741 41.023",
        },
      }),
      _c("polygon", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          points:
            "15.388 84.473 15.388 86.223 17.325 86.223 36.534 86.223 38.327 86.223 37.588 85.042 37.588 84.54 37.588 84.473 16.263 84.473 15.388 84.473",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m35.316,38.303h2.146c.483,0,.875-.392.875-.875s-.392-.875-.875-.875h-21.075c-.483,0-.875.392-.875.875s.392.875.875.875h18.929Z",
        },
      }),
      _c("polygon", {
        staticStyle: { fill: "#fff", "stroke-width": "0px" },
        attrs: {
          points:
            "83.737 57.828 62.412 57.828 62.412 73.072 83.737 73.072 83.737 72.593 83.737 57.828",
        },
      }),
      _c("polygon", {
        staticStyle: { fill: "#fff", "stroke-width": "0px" },
        attrs: {
          points:
            "83.718 84.473 83.733 75.072 62.412 75.072 62.412 84.473 83.718 84.473",
        },
      }),
      _c("path", {
        staticStyle: { fill: "#fff", "stroke-width": "0px" },
        attrs: {
          d: "m64.208,87.41c.113.18.307.287.52.287h16.694c.212,0,.406-.107.52-.288l.742-1.187h-19.219l.743,1.188Z",
        },
      }),
      _c("path", {
        staticStyle: { fill: "#fff", "stroke-width": "0px" },
        attrs: {
          d: "m83.161,43.199l-.663-1.301h-18.848l-.663,1.301c-.376.739-.575,1.567-.575,2.396v10.234h21.325v-10.234c0-.829-.199-1.657-.576-2.395Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m62.412,45.594c0-.828.199-1.657.575-2.396l.663-1.301h18.848l.663,1.301c.377.738.576,1.566.576,2.395v10.234h1.75v-10.234c0-1.104-.266-2.207-.768-3.19l-.768-1.508c-.158-.309-.425-.529-.736-.648v.775h-1.75v-.875h-16.575v.875h-1.75v-.837c-.401.084-.751.334-.944.712l-.659,1.293.108.212c.502.982.767,2.085.767,3.19Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m83.733,75.072l-.015,9.4h.894v1.75h-1.928l-.742,1.187c-.113.181-.308.288-.52.288h-16.694c-.213,0-.406-.107-.52-.287l-.743-1.188h-1.792l-.136.217,1.188,1.898c.435.694,1.183,1.109,2.003,1.109h16.694c.818,0,1.567-.414,2.003-1.109l1.779-2.843c.186-.3.283-.643.283-.991v-9.432h-1.754Z",
        },
      }),
      _c("polygon", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          points:
            "81.466 40.148 81.466 41.023 83.216 41.023 83.216 40.249 83.216 38.303 81.466 38.303 81.466 40.148",
        },
      }),
      _c("polygon", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          points:
            "64.891 41.023 64.891 40.148 64.891 38.303 63.141 38.303 63.141 40.187 63.141 41.023 64.891 41.023",
        },
      }),
      _c("polygon", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          points:
            "62.412 84.54 62.412 85.042 61.673 86.223 63.465 86.223 82.684 86.223 84.612 86.223 84.612 84.473 83.718 84.473 62.412 84.473 62.412 84.54",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m81.466,38.303h2.146c.483,0,.875-.392.875-.875s-.392-.875-.875-.875h-21.075c-.483,0-.875.392-.875.875s.392.875.875.875h18.929Z",
        },
      }),
      _c("path", {
        staticStyle: { fill: "#fff", "stroke-width": "0px" },
        attrs: {
          d: "m41.134,87.41c.113.18.307.287.519.287h16.695c.212,0,.405-.107.518-.287l.743-1.188h-19.218l.743,1.188Z",
        },
      }),
      _c("rect", {
        staticStyle: { fill: "#fff", "stroke-width": "0px" },
        attrs: { x: "39.338", y: "57.828", width: "21.324", height: "15.244" },
      }),
      _c("rect", {
        staticStyle: { fill: "#fff", "stroke-width": "0px" },
        attrs: { x: "39.338", y: "75.072", width: "21.324", height: "9.4" },
      }),
      _c("path", {
        staticStyle: { fill: "#fff", "stroke-width": "0px" },
        attrs: {
          d: "m60.087,43.199l-.663-1.301h-18.848l-.663,1.301c-.376.738-.575,1.566-.575,2.396v10.234h21.324v-10.234c0-.83-.199-1.658-.575-2.395Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m37.588,45.594v10.234h1.75v-10.234c0-.83.199-1.658.575-2.396l.663-1.301h18.848l.663,1.301c.376.737.575,1.565.575,2.395v10.234h1.75v-10.234c0-1.105-.265-2.208-.767-3.19l-.108-.212-.658-1.292c-.158-.31-.425-.532-.737-.651v.775h-1.75v-.875h-16.576v.875h-1.75v-.837c-.403.084-.753.335-.943.712l-.659,1.293-.108.212c-.502.982-.767,2.086-.767,3.191Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m62.412,85.042v-9.97h-1.75v9.4h.875v.875h0,0v.875h-1.928l-.743,1.188c-.112.18-.306.287-.518.287h-16.695c-.212,0-.405-.107-.519-.287l-.743-1.188h-1.928v-.875h0,0v-.875h.875v-9.4h-1.75v9.97l.739,1.181.136.217,1.188,1.898c.435.694,1.183,1.109,2.002,1.109h16.695c.819,0,1.567-.415,2.001-1.109l1.188-1.898.136-.217.739-1.181Z",
        },
      }),
      _c("polygon", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          points:
            "58.392 40.148 58.392 41.023 60.142 41.023 60.142 40.249 60.142 38.303 58.392 38.303 58.392 40.148",
        },
      }),
      _c("polygon", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          points:
            "41.815 41.023 41.815 40.148 41.815 38.303 40.065 38.303 40.065 40.187 40.065 41.023 41.815 41.023",
        },
      }),
      _c("polygon", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          points:
            "38.463 84.473 38.463 85.347 38.463 86.223 40.391 86.223 59.609 86.223 61.537 86.223 61.537 85.347 61.537 84.473 60.662 84.473 39.338 84.473 38.463 84.473",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m58.392,38.303h2.146c.483,0,.875-.392.875-.875s-.392-.875-.875-.875h-21.074c-.483,0-.875.392-.875.875s.392.875.875.875h18.929Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m87.349,55.828H12.651c-1.103,0-2,.897-2,2v15.244c0,1.103.897,2,2,2h74.697c1.103,0,2-.897,2-2v-15.244c0-1.103-.897-2-2-2Zm-1.861,17.244H12.651v-15.244h74.697v15.244s-1.861,0-1.861,0Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }